import { List } from "@/components/list/List";
import { Flex, Modal, Tooltip } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Ellipsis from "../../../../common/components/views/Ellipsis";
import HtmlView from "../../../../common/components/views/HtmlView";
import { ModalSizes } from "../../../../common/constants";
import { formatLocaleDateTime } from "../../../../common/utils/formatUtils";
import {
  DashboardNoticeAttachments,
  DashboardNoticeIcon,
} from "../../../dashboard/components/widgets/notices/components";
import { DashboardNotice } from "../../../dashboard/types";

interface Props {
  open: boolean;
  notices: DashboardNotice[];
  onCancel: () => void;
}

export const CalcNoticesModal = ({ open, notices, onCancel }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      width={ModalSizes.MEDIUM}
      open={open}
      title={t("calc.titles.notices")}
      forceRender
      closable
      okButtonProps={{ style: { display: "none" } }}
      cancelText={t("common.close")}
      className="calc-notices-modal"
      onCancel={onCancel}
    >
      <div style={{ maxHeight: "65svh", overflow: "auto" }}>
        <List<DashboardNotice>
          items={notices}
          gap={12}
          split
          showEmpty
          rowKey={(item) => item.id}
          renderItem={(item) => (
            <>
              <Flex align="start" gap={16} style={{ marginBottom: 16 }}>
                <DashboardNoticeIcon type={item.type} />

                <div style={{ flex: "1 0", width: 0 }}>
                  <h4
                    style={{
                      margin: "0 0 var(--ant-padding-sm)",
                      fontSize: "var(--ant-font-size-lg)",
                      lineHeight: "var(--ant-line-height-lg)",
                    }}
                  >
                    <Ellipsis>{item.title}</Ellipsis>
                  </h4>

                  <div style={{ color: "var(--ant-color-text-description)" }}>
                    <Tooltip title={formatLocaleDateTime(item.createdAt)}>{dayjs(item.createdAt).fromNow()}</Tooltip>
                  </div>
                </div>
              </Flex>

              <HtmlView value={item.text} />

              {item.attachments.length ? (
                <div style={{ marginTop: 16 }}>
                  <DashboardNoticeAttachments noticeId={item.id} attachments={item.attachments} />
                </div>
              ) : undefined}
            </>
          )}
        />
      </div>
    </Modal>
  );
};
